import type { ReferenceEmbed } from '@cult/schemas';
import { RoundTag, type TagShape } from '../../../../components';

/** Frameworks render as rounded rectangles so they read apart from core-value pills. */
export const FRAMEWORK_TAG_SHAPE: TagShape = 'rounded';

type Props = {
  value: Pick<ReferenceEmbed, 'name' | 'color'>;
  shape?: TagShape;
};

export const ReferenceTag = ({ value, shape }: Props) => (
  <RoundTag label={value.name} color={value.color} shape={shape} />
);
